export const VALUE_LIMITS = {
  thing: 20,
  character_string: 32,
  phrase: 5,
  const: 20,
  phone_number: 17,
  car_number: 8
}

const PLACEHOLDER = '\\{\\{\\s*([a-z][a-z_]*\\d{0,3})\\.DATA\\s*\\}\\}'
const CONTAINS_PLACEHOLDER = new RegExp(PLACEHOLDER)
const LEADING_PLACEHOLDER = new RegExp(`^\\s*${PLACEHOLDER}`)

export function truncateForKey(key, value) {
  const prefix = (key.match(/^[a-z_]+/) || [])[0] || ''
  const limit = VALUE_LIMITS[prefix]
  if (!limit || value.length <= limit) return value
  return `${value.slice(0, limit - 1)}…`
}

export function mappingRows(fields, sources) {
  const sourceByKey = {}
  sources.forEach((source) => {
    sourceByKey[source.key] = source
  })

  return fields
    .filter((field) => field.key && field.key.trim() !== '')
    .map((field) => {
      const source = sourceByKey[field.source]
      return {
        key: field.key,
        sample: source ? truncateForKey(field.key, source.sample) : null
      }
    })
}

function stripLabelSeparator(text) {
  return text.trim().replace(/[:：]$/, '').trim()
}

function segmentsOf(line, fields, sources) {
  const sourceByKey = {}
  const fieldByKey = {}
  sources.forEach((source) => {
    sourceByKey[source.key] = source
  })
  fields.forEach((field) => {
    fieldByKey[field.key] = field
  })

  const segments = []
  let lastIndex = 0
  const pattern = new RegExp(PLACEHOLDER, 'g')
  let match

  while ((match = pattern.exec(line)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ text: line.slice(lastIndex, match.index), kind: 'text' })
    }

    const key = match[1]
    const source = sourceByKey[(fieldByKey[key] || {}).source]
    if (source) {
      segments.push({ text: truncateForKey(key, source.sample), kind: 'value' })
    } else {
      segments.push({ text: '未设置', kind: 'unmapped' })
    }
    lastIndex = match.index + match[0].length
  }

  if (lastIndex < line.length) {
    segments.push({ text: line.slice(lastIndex), kind: 'text' })
  }
  return segments
}

export function renderPreviewLines(content, fields, sources) {
  const rawLines = content.split('\n')
  const lines = []

  for (let index = 0; index < rawLines.length; index += 1) {
    const line = rawLines[index]
    const next = rawLines[index + 1]

    if (
      next !== undefined &&
      line.trim() !== '' &&
      !CONTAINS_PLACEHOLDER.test(line) &&
      LEADING_PLACEHOLDER.test(next)
    ) {
      lines.push({ label: stripLabelSeparator(line), segments: segmentsOf(next, fields, sources) })
      index += 1
      continue
    }

    lines.push({ segments: segmentsOf(line, fields, sources) })
  }

  return lines
}

export function truncated(row, sources) {
  const source = sources.find((item) => item.key === row.source)
  if (!source) return false
  return truncateForKey(row.key, source.sample) !== source.sample
}
